import { css } from 'lit';

export const styles = css`
  .multi-select-wrapper {
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(34, 34, 34);
    width: calc(100% - calc(34rem / var(--default-rem-px-count)));
    margin: calc(20rem / var(--default-rem-px-count)) 0;
    padding: calc(4rem / var(--default-rem-px-count))
      calc(16rem / var(--default-rem-px-count));
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    cursor: pointer;
  }

  .select-arrow {
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto 0;
    padding: 0 2px;
  }

  .arrow-closed {
    transform: rotate(90deg);
  }

  .arrow-expanded {
    transform: rotate(270deg);
  }

  .options-content,
  .options-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: calc(15em / var(--default-rem-px-count));
    padding-bottom: calc(16rem / var(--default-rem-px-count));
  }

  .options-content .side {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .option-category-header {
    font-weight: 500;
    margin: calc(16rem / var(--default-rem-px-count)) 0;
  }

  .options-buttons {
    padding-top: calc(12rem / var(--default-rem-px-count));
  }

  .options-buttons cta-button {
    flex-grow: 1;
  }

  /* Custom Checkbox Styling */

  .filter-option {
    padding: calc(4rem / var(--default-rem-px-count)) 0;
  }

  .filter-option label {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* For iPhone, any font size < 16px will trigger a zoom that breaks the UI  */
  input[type='text'] {
    font-size: max(1rem, 16px);
  }

  .option-label-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: calc(8rem / var(--default-rem-px-count));
    height: calc(16rem / var(--default-rem-px-count));
    width: calc(16rem / var(--default-rem-px-count));
    border: 1px solid black;
  }

  .option-label-checkbox div {
    height: calc(100% - calc(4rem / var(--default-rem-px-count)));
    width: calc(100% - calc(4rem / var(--default-rem-px-count)));
  }

  .option-label:hover span div {
    background-color: #dddddd;
  }

  .option-label-checkbox input:checked ~ div {
    background-color: #ff993d;
  }

  .input-wrapper {
    flex-grow: 1;
    position: relative;
    display: flex;
  }

  .input-wrapper.search {
    border: 1px solid #222222;
  }

  .search input {
    width: 100%;
  }

  /* Override browser defaults */
  input {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
    background: none;
  }

  input {
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-left: calc(16rem / var(--default-rem-px-count));
    display: block;
  }

  .search-icon {
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-right: calc(16rem / var(--default-rem-px-count));
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto;
  }

  @media (min-width: 600px) {
    input[type='text'] {
      font-size: inherit;
    }
  }
`;
